<app-header #headerComponent></app-header>

<div class="container-fluid g-0 ">

  <div class="row g-0" [style.height]="'calc(100vh - ' + headerHeight() + 'px)'">

    <div class="col-md-3 d-md-block bg-secondary sidebar" [class.d-none]="isCollapsed">

      <div class="sticky-top overflow-scroll border-end border-1 d-md-grid vh-100"
           [class.d-none]="isCollapsed"
           [style.margin-top]="'-' + headerHeight() + 'px'"
           [style.padding-top]="headerHeight() + 'px'">
        <div class="container-fluid sidebar-container g-0 mt-md-1">
          <button type="button" class="btn btn-link text-white ms-2 d-md-none" (click)="isCollapsed = !isCollapsed"
                  [attr.aria-expanded]="!isCollapsed" aria-controls="collapseEvent">
            <i class="fa fa-times fa-2x"></i>
          </button>
          <app-sidebar></app-sidebar>
        </div>

        <div class="container-fluid g-0 mt-auto">
          <nav class="list-group list-group-flush">
            @if (user) {
              <a routerLink="/account"
                 class="list-group-item list-group-item-sidebar-secondary list-group-item-non-hover border-0">
                <i class="fa-solid fa-user align-middle ms-1 me-2"></i>
                {{ `${user.first_name} ${user.last_name}` }}
              </a>

              <button
                (click)="switchLang(locale === 'de' ? 'en' : 'de')"
                type="button" id="user-account-dropdown" aria-expanded="false"
                class="list-group-item list-group-item-sidebar-secondary list-group-item-non-hover border-0 text-start">
                <i class="fa-solid fa-globe align-middle ms-1 me-2"></i>
                <span [class.fw-bold]="locale === 'de'">{{ 'header.language_menu.de'| translate }}</span> | <span
                [class.fw-bold]="locale === 'en'">{{ 'header.language_menu.en'| translate }}</span>
              </button>
            }

            <a class="list-group-item list-group-item-sidebar-secondary list-group-item-non-hover border-0"
               href="https://hello-one.de/de/dnjs385ns92rn9n35n2n49cd/home" target="_blank" title="Knowledge Base">
              <i class="fa-solid fa-circle-question align-middle ms-1 me-2"></i> Helpcenter
            </a>

            <li class="list-group-item list-group-item-sidebar-secondary list-group-item-non-hover small">
              <p class="m-0"><a class="link-light text-decoration-none" target="_blank" href="https://hello-one.de">hello one</a> | enterprise
                V{{ appVersion }}</p>
              <p class="m-0">© {{ currentYear }} - <a class="link-light text-decoration-none" target="_blank" href="https://teraone.de">teraone
                GmbH</a></p>
            </li>
          </nav>
        </div>
      </div>
    </div>

    <main class="col h-100">

      <div style="height: calc(100vh - {{ headerHeight() }}px) !important;" class="overflow-scroll ">
        <div class="h-100 w-100 d-block container-fluid py-3">
          <router-outlet></router-outlet>
        </div>

      </div>

    </main>
  </div>
</div>
